import properties from "./properties";
import enums from "./enums";
let currentStore;
const init = (store)=>{
  currentStore= store;
}

const prepareErrorObj = (url, action, message, cause, code)=>{
  let loginStatus = "not logged in";
  if(currentStore.getters.getLoggedIn){
    loginStatus="logged in";
  }
  const clientConfig = currentStore.getters.getConfigurations.client;
  let clientId;
  if (clientConfig && clientConfig.client) {
    clientId = clientConfig.client.client_id;
  }
  return {
    "OriginalClientUrl" : currentStore.getters.getOriginalUrl,
    "clientName": currentStore.state.configurationParams.client || 'gcdmone',
    "GCDMClientName": currentStore.state.configurationParams.client || 'gcdmone',
    "GCDMClientId": clientId || currentStore.getters.configure('key_for_internal_client_id'),
    "countryCode": currentStore.state.configurationParams.country,
    "language": currentStore.state.configurationParams.language,
    "brand": currentStore.state.configurationParams.brand,
    "errorUrl": url,
    "errorAction": action,
    "errorMessage": message,
    "errorCause": cause,
    "errorType": 'backend 1st party',
    "errorCode": code,
    "errorOrigin": 'GCDM',
    "loginStatus": loginStatus,
    "ErrorTime": new Date().getTime()
  };
}

const getDefaultErrorObj = (url, error)=>{
  let loginStatus = "not logged in";
  if(currentStore.getters.getLoggedIn){
    loginStatus="logged in";
  }
  const clientConfig = currentStore.getters.getConfigurations.client;
  let clientId;
  if (clientConfig && clientConfig.client) {
    clientId = clientConfig.client.client_id;
  }
  return {
    "OriginalClientUrl" : currentStore.getters.getOriginalUrl,
    "clientName": currentStore.state.configurationParams.client || 'gcdmone',
    "GCDMClientName": currentStore.state.configurationParams.client || 'gcdmone',
    "GCDMClientId": clientId || currentStore.getters.configure('key_for_internal_client_id'),
    "countryCode": currentStore.state.configurationParams.country,
    "language": currentStore.state.configurationParams.language,
    "brand": currentStore.state.configurationParams.brand,
    "errorUrl": url,
    "errorAction": "track",
    "errorMessage": error,
    "errorCause": "tracking error",
    "errorType": 'frontend',
    "errorCode": '00',
    "errorOrigin": origin,
    "loginStatus": loginStatus,
    "ErrorTime": new Date().getTime()
  };
}

const checkErrorAPI = (errorObj, lastCall)=>{
  if(properties.ESIMAPI.includes(lastCall)){
    errorObj.errorType = 'backend 3rd party';
    errorObj.errorOrigin = 'ESIM';
  }
  if(properties.VISAPI.includes(lastCall)){
    errorObj.errorType = 'backend 3rd party';
    errorObj.errorOrigin = 'VIS';
  }
  if(properties.THIRDPARTYAPI.includes(lastCall)){
    errorObj.errorType = 'backend 3rd party';
    errorObj.errorOrigin = lastCall;
  }
  return errorObj;
}

const prepareMessages = (errorObj,lastCall)=>{
  if(!errorObj.errorMessage) errorObj.errorMessage = "Error while: "+lastCall;
  if(!errorObj.errorCause) errorObj.errorCause = errorObj.errorCode;
  if(errorObj.errorMessage && errorObj.errorMessage.split("'text':'")[1] ){ 
    const messageSplitted = errorObj.errorMessage.split("'text':'");
    const messageSplittedFirstPart = messageSplitted[1];
    const messageSplittedFirstPartSplitted = messageSplittedFirstPart.split("',");
    const messageSplittedFirstPartSplittedSecondPart = messageSplittedFirstPartSplitted[1];
    const messageSplittedFirstPartSplittedSecondPartSplitted = messageSplittedFirstPartSplittedSecondPart.split(']');
    errorObj.errorMessage = (messageSplittedFirstPartSplitted[0]=='null' ? '' : messageSplittedFirstPartSplitted[0])+'-'+messageSplittedFirstPartSplittedSecondPartSplitted[1];
  }
  return errorObj
}

const checkLastCall = (errorObj,lastCall)=>{
  
  if(lastCall=='resetChangePassword' && errorObj.errorMessage.split("'") && errorObj.errorMessage.split("'")[1]){
    errorObj.errorMessage = errorObj.errorMessage.split("'")[0]+"***"+errorObj.errorMessage.split("'")[2];
  }
  if(lastCall=='changePassword' && errorObj.errorMessage.split("'") && errorObj.errorMessage.split("'")[1]){
    errorObj.errorMessage = errorObj.errorMessage.split("'")[0];
  }
  if(lastCall=='changePassword' && (errorObj.errorCode==enums.errorReasons.WRONG_PASSWORD || errorObj.errorCode==enums.errorReasons.ALREADY_USED)){
    errorObj.errorType = 'user';
  }
  if(lastCall=='changeId' && (errorObj.errorCode==enums.errorReasons.ALREADY_USED)){
    errorObj.errorType = 'user';
  }
  if(lastCall=='updateUser' && (errorObj.errorCode==enums.errorReasons.ALREADY_USED)){
    errorObj.errorType = 'user';
  }
  if(lastCall=='passkeyLoginComplete'){
    errorObj.errorType = 'passkey';
  }
  return errorObj
}

const cleanMessages = (errorObj,lastCall)=>{
  
  
  if(errorObj.errorMessage.includes("Token '")){
    const messageSplittedPsu = errorObj.errorMessage.split("Token '");
    const messageSplittedPsu2 = messageSplittedPsu[1].split("'");
    errorObj.errorMessage = messageSplittedPsu[0]+'Token ***'+messageSplittedPsu2[1];
  }
  if(errorObj.errorMessage.includes('GUID')){
    const messageSplittedCi = errorObj.errorMessage.split("GUID");
    const messageSplittedCi2 = messageSplittedCi[1].split("does");
    errorObj.errorMessage = messageSplittedCi[0]+'GUID *** does'+messageSplittedCi2[1];
  }
  return errorObj
}

const trackError = (url, action, message, cause, code, lastCall)=>{

  let errorObj = prepareErrorObj(url, action, message, cause, code);
  errorObj = checkErrorAPI(errorObj, lastCall);
 
  try {
    errorObj = prepareMessages(errorObj,lastCall);
    errorObj = checkLastCall(errorObj,lastCall);
    errorObj = cleanMessages(errorObj,lastCall);
  } catch (error) {
    errorObj = getDefaultErrorObj(url, error);
  }
  const ref = "one > "+ (window.location.hash ? window.location.hash.split('/')[1].split('?')[0] : 'profilewebcomponent');
  return errorObj;
}


const getPageDetails = ()=>{
  const clientConfig = currentStore.getters.getConfigurations.client;
  let clientId;
  if (clientConfig && clientConfig.client) {
    clientId = clientConfig.client.client_id;
  }
  return {
    "OriginalClientUrl" : currentStore.getters.getOriginalUrl,
    "GCDMClientName": currentStore.state.configurationParams.client || 'gcdmone',
    "GCDMClientId": clientId || currentStore.getters.configure('key_for_internal_client_id'),
    "countryCode": currentStore.state.configurationParams.country,
    "lang": currentStore.state.configurationParams.language,
    "brand": currentStore.state.configurationParams.brand,
    "returningStatus": "datalayer field empty",
    "customerType": "datalayer field empty",
    "loggedInStatus": currentStore.getters.getLoggedIn ? "logged in" : "not logged in",
    "Segment": "datalayer field empty",
    "eventPoints": new Date().getTime()

  };
}

const areEpaasAndTracyEnabled = function(){
  const areEpaasAndTracyEnabledGlobal = currentStore.getters.configure("enable_epaas_&_tracy_tracking_global");
  const areEpaasAndTracyEnabledClient = currentStore.getters.configure("enable_epaas_&_tracy_tracking");
  if (areEpaasAndTracyEnabledGlobal && areEpaasAndTracyEnabledClient !== undefined) {
       return areEpaasAndTracyEnabledClient;
  }
  return areEpaasAndTracyEnabledGlobal;
}

const prepareEpaasParameters = (url)=>{
  if(window['epaas'] && window['epaas'].api.isInitialized()){
    const epaasConsenttoken = window['epaas'].api.createConsentToken();
    console.log('EPAAS TOKENS: ');
    console.log('epaasConsenttoken ',epaasConsenttoken);
    if(epaasConsenttoken){
      url=url+"?epaas_consenttoken="+epaasConsenttoken;
    }
  }
  return url;
}



export default {
  init,

  prepareEpaasParameters,

  trackError
};
